import { render } from "./TheServices.vue?vue&type=template&id=b3165ca0"
import script from "./TheServices.vue?vue&type=script&lang=js"
export * from "./TheServices.vue?vue&type=script&lang=js"

import "./TheServices.vue?vue&type=style&index=0&id=b3165ca0&lang=scss"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__